export const mobileMenuOverlayId = "mobile-menu";

export const miniCartOverlayId = "mini-cart";
